import { Button, Table } from "@osttra/ds-react";
import { ApplicationApiResponse } from "../app-gallery/Applications";
import "./ApplicationTableView.css";

const ApplicationTableView = ({ applications, userMail }: ApplicationApiResponse) => {
  return (
    <Table wide>
      <Table.Head>
        <Table.HeadRow>
          <Table.HeadCell>App</Table.HeadCell>
          <Table.HeadCell>User</Table.HeadCell>
          <Table.HeadCell className="last-col">Launch</Table.HeadCell>
        </Table.HeadRow>
      </Table.Head>
      <Table.Body>
        {applications.map((app, index) => (
          <Table.Row rowIndex={index}>
            <Table.Cell>{app.appName}</Table.Cell>
            <Table.Cell>{userMail}</Table.Cell>
            <Table.Cell className="last-col">
              <Button type="primary" variant="outlined" icon="external-link">
                <a className="homepage-url-link" href={app.homepageUrl} target="_blank" rel="noopener noreferrer">
                  Launch
                </a>
              </Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default ApplicationTableView;
